<template>

  <div class="row primary-hero">
    <div class="col-md-12 col-lg-7 left">
      <h2 v-html="$t('home-heading-title')"></h2>
      <h3 class="mt-3">{{ $t('home-subheading') }}</h3>
      <p class="mt-3">{{ $t('home-description') }}</p>
      <div class="sub-title mb-4">{{ $t('home-subtitle') }}</div>
      <div class="hero-cta-row">
        <MainButton @click="goToDownload">{{ $t('home-signup-button') }}</MainButton>
        <div class="store-badges">
          <a
            href="https://play.google.com/store/apps/details?id=com.momfident.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GooglePlay />
          </a>
          <a
            href="https://apps.apple.com/us/app/momfident/id6751100834"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AppStore />
          </a>
        </div>
      </div>
    </div>
    <div class="col-md-5 p-0 position-relative image-wrapper">
      <img v-bind:src="'/static/primary-hero-right-' +  locale + '.png'" class="img" />
    </div>
  </div>

</template>

<script setup>
import MainButton from '@/components/Common/Buttons/MainButton.vue';
import GooglePlay from "@/components/Common/Buttons/GooglePlay.vue";
import AppStore from "@/components/Common/Buttons/AppStore.vue";
import {useI18n} from "vue-i18n";
import { useRouter } from 'vue-router';

const router = useRouter();
const {locale} = useI18n();

function goToDownload() {
  const targetRoute = locale.value === 'en' ? 'download-en' : 'download';
  router.push({ name: targetRoute });
}
</script>

<style lang="scss" scoped>

.primary-hero {
  background: $color-pink-light;
  border-radius: 30px;
  overflow: hidden;

  .image-wrapper {
    img { max-height: 100%; width: auto; max-width: 100%; }
  }

  .left {
    padding: 100px;
    color: $color-purple;

    .hero-cta-row {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 14px 18px;
    }

    .store-badges {
      display: flex;
      align-items: center;
      gap: 12px;

      a {
        display: inline-flex;
        line-height: 0;
        transition: transform 0.2s ease;

        &:hover {
          transform: translateY(-2px);
        }
      }

      :deep(svg) {
        height: 44px;
        width: auto;
      }
    }

    h3 {
      font-size: 22px;
      font-weight: 500;
    }

    h2 {
      font-family: $font-thin;
      font-size: 50px;
      font-weight: 300;
      line-height: 1;
    }

    p {
      font-size: 14px;
      font-weight: 100;
    }
  }

  .img {
    max-width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
  }


  @media (max-width: 992px) {
    .left {
      padding: 40px;
      h2 { font-size: 30px; }
      h3 { font-size: 15px; }

      .store-badges :deep(svg) {
        height: 40px;
      }
    }
    .image-wrapper {
      display: none;
    }
  }

  @media (max-width: 768px) {
    .primary-hero {
      border-radius: 20px;
    }
    .left {
      padding: 24px 20px 28px;
      h2 { font-size: 24px; }
      h3 { font-size: 14px; }
      p { font-size: 13px; }
      .sub-title { font-size: 13px; }

      .hero-cta-row {
        gap: 12px 14px;
      }

      .store-badges :deep(svg) {
        height: 38px;
      }
    }
  }
}

</style>